import axios from 'axios'

const studentPayment = async ({data}) => {
  const res = await axios.post('/api/rep/student-payments', data)
  return res.data
}

const orgPayment = async ({data}) => {
  const res = await axios.post('/api/rep/org-payments', data)
  return res.data
}

const reportService = {
  orgPayment,
  studentPayment,
}

export default reportService
